import { render, staticRenderFns } from "./SolicitudPartes.vue?vue&type=template&id=654f9ae0&scoped=true&lang=pug"
import script from "./SolicitudPartes.vue?vue&type=script&lang=js"
export * from "./SolicitudPartes.vue?vue&type=script&lang=js"
import style0 from "./SolicitudPartes.vue?vue&type=style&index=0&id=654f9ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654f9ae0",
  null
  
)

export default component.exports